import {
  ADD_SECTION,
  ADD_CONTENT_BLOCK,
  UPDATE_CONTENT_BLOCK,
  SET_ACTIVE_STORE,
  REMOVE_SECTION,
  REMOVE_CONTENT_BLOCK,
  UPDATE_SECTION,
  UPDATE_STORE_CONFIG,
  MOVE_CONTENT_BLOCK,
  SET_MODIFIED,
  ADD_CATEGORY,
  ADD_SUBCATEGORY,
  UPDATE_CATEGORY,
  UPDATE_SUBCATEGORY,
  REMOVE_CATEGORY,
  REMOVE_SUBCATEGORY,
  SET_STORE_VERSIONS,
  UPDATE_BACKLINK
} from './actionTypes';

const initialState = {
  activeStore: 'apple',
  modified: false,
  version: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_STORE:
      return {
        ...state,
        modified: false,
        [action.id]: action.store,
        activeStore: action.id,
        version: action.version
      };

    case SET_MODIFIED:
      return {
        ...state,
        modified: false
      };

    case ADD_SECTION:
      const activeStore = state[state.activeStore];

      return {
        ...state,
        modified: true,
        [state.activeStore]: {
          ...activeStore,
          landingPage: {
            ...activeStore.landingPage,
            sections: [
              ...activeStore.landingPage.sections,
              {
                contentBlocks: []
              }
            ]
          }
        }
      };

    case ADD_CONTENT_BLOCK:
      const newActiveStore = Object.assign({}, state[state.activeStore]);
      newActiveStore.landingPage.sections[action.index].contentBlocks = [
        ...newActiveStore.landingPage.sections[action.index].contentBlocks,
        action.contentBlock
      ];

      return {
        ...state,
        modified: true,
        [state.activeStore]: newActiveStore
      };
    case UPDATE_CONTENT_BLOCK:
      const newActiveStoreContent = Object.assign({}, state[state.activeStore]);

      newActiveStoreContent.landingPage.sections[action.sectionIndex] = {
        ...newActiveStoreContent.landingPage.sections[action.sectionIndex],
        ...(newActiveStoreContent.landingPage.sections[
          action.sectionIndex
        ].contentBlocks[action.contentBlockIndex] = action.contentBlock)
      };

      return {
        ...state,
        modified: true,
        [state.activeStore]: newActiveStoreContent
      };

    case REMOVE_SECTION:
      let newSectionsArray = state[
        state.activeStore
      ].landingPage.sections.slice();
      newSectionsArray.splice(action.sectionIndex, 1);

      return {
        ...state,
        modified: true,
        [state.activeStore]: {
          ...state[state.activeStore],
          landingPage: {
            ...state[state.activeStore].landingPage,
            sections: newSectionsArray
          }
        }
      };
    case MOVE_CONTENT_BLOCK:
      let newState = Object.assign({}, state, {
        modified: true
      });
      const srcSection =
        newState[state.activeStore].landingPage.sections[action.srcSectionIdx];
      const srcContentBlock =
        srcSection.contentBlocks[action.srcContentBlockIdx];
      const dstSection =
        newState[state.activeStore].landingPage.sections[action.dstSectionIdx];

      if (action.srcSectionIdx === action.dstSectionIdx) {
        if (action.dstContentBlockIdx > action.srcContentBlockIdx) {
          dstSection.contentBlocks.splice(
            action.dstContentBlockIdx + 1,
            0,
            srcContentBlock
          );
          srcSection.contentBlocks.splice(action.srcContentBlockIdx, 1);
        } else {
          dstSection.contentBlocks.splice(
            action.dstContentBlockIdx,
            0,
            srcContentBlock
          );
          srcSection.contentBlocks.splice(action.srcContentBlockIdx + 1, 1);
        }
      } else {
        dstSection.contentBlocks.splice(
          action.dstContentBlockIdx,
          0,
          srcContentBlock
        );
        srcSection.contentBlocks.splice(action.srcContentBlockIdx, 1);
      }

      return newState;
    case UPDATE_SECTION:
      const newActiveStoreSection = Object.assign({}, state[state.activeStore]);

      newActiveStoreSection.landingPage.sections = action.sectionsData;

      return {
        ...state,
        modified: true,
        [state.activeStore]: newActiveStoreSection
      };

    case REMOVE_CONTENT_BLOCK:
      let newContentBlockArray = state[state.activeStore].landingPage.sections;
      newContentBlockArray[action.sectionIndex].contentBlocks.slice();

      newContentBlockArray[action.sectionIndex].contentBlocks.splice(
        action.contentBlockIndex,
        1
      );

      return {
        ...state,
        modified: true,
        [state.activeStore]: {
          ...state[state.activeStore],
          landingPage: {
            ...state[state.activeStore].landingPage,
            sections: newContentBlockArray
          }
        }
      };

    case ADD_CATEGORY:
      const activeStoreCategory = state[state.activeStore];

      return {
        ...state,
        modified: true,
        [state.activeStore]: {
          ...activeStoreCategory,
          categories: [
            ...(activeStoreCategory.categories || []),
            {
              ...action.category,
              subcategories: []
            }
          ]
        }
      };

    case ADD_SUBCATEGORY:
      const newActiveStoreSubcat = Object.assign({}, state[state.activeStore]);
      newActiveStoreSubcat.categories[action.index].subcategories = [
        ...newActiveStoreSubcat.categories[action.index].subcategories,
        action.subcategory
      ];

      return {
        ...state,
        modified: true,
        [state.activeStore]: newActiveStoreSubcat
      };
    case UPDATE_SUBCATEGORY:
      const newStore = Object.assign({}, state[state.activeStore]);

      newStore.categories[action.categoryIndex].subcategories =
        action.subcategories;

      return {
        ...state,
        modified: true,
        [state.activeStore]: newStore
      };

    case REMOVE_CATEGORY:
      let newCategoriesArray = state[state.activeStore].categories.slice();
      newCategoriesArray.splice(action.categoryIndex, 1);

      return {
        ...state,
        modified: true,
        [state.activeStore]: {
          ...state[state.activeStore],
          categories: newCategoriesArray
        }
      };

    case UPDATE_CATEGORY:
      const newActiveStoreCategory = Object.assign(
        {},
        state[state.activeStore]
      );

      newActiveStoreCategory.categories = action.categoriesData;

      return {
        ...state,
        modified: true,
        [state.activeStore]: newActiveStoreCategory
      };

    case REMOVE_SUBCATEGORY:
      const newSubcategoryArray = Object.assign({}, state[state.activeStore]);

      newSubcategoryArray.categories[action.categoryIndex] = {
        ...newSubcategoryArray.categories[action.categoryIndex],
        ...(newSubcategoryArray.categories[
          action.categoryIndex
        ].subcategories = [
          ...newSubcategoryArray.categories[
            action.categoryIndex
          ].subcategories.filter(
            (item, index) => action.subcategoryIndex !== index
          )
        ])
      };

      return {
        ...state,
        modified: true,
        [state.activeStore]: newSubcategoryArray
      };

    case UPDATE_STORE_CONFIG:
      return {
        ...state,
        modified: true,
        [action.storeId]: {
          ...state[action.storeId],
          ...action.config
        }
      };
    case SET_STORE_VERSIONS:
      return {
        ...state,
        [action.storeId]: {
          ...state[action.storeId],
          versions: action.versions
        }
      };
    case UPDATE_BACKLINK:
      const activeStoreData = state[state.activeStore];
      return {
        ...state,
        [state.activeStore]: {
          ...activeStoreData,
          backlink: action.backlink
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/editStoreReducer.js